import { Ability } from "@casl/ability";

export default new Ability();
